const isNodeConfig = (c) => c.type === "node";
const isMarkConfig = (c) => c.type === "mark";
const isExtensionConfig = (c) => c.type === "extension";
const Mark_Type = {
  ANCHOR: "ANCHOR",
  BOLD: "BOLD",
  COLOR_BACKGROUND: "COLOR_BACKGROUND",
  COLOR_FOREGROUND: "COLOR_FOREGROUND",
  EXTERNAL: "EXTERNAL",
  FONT_SIZE: "FONT_SIZE",
  HASHTAG: "HASHTAG",
  ITALIC: "ITALIC",
  LINK: "LINK",
  MENTION: "MENTION",
  SPOILER: "SPOILER",
  UNDERLINE: "UNDERLINE",
  UNRECOGNIZED: "UNRECOGNIZED"
};
const isRicosNodeExtension = (ext) => ext.type === "react-node" || ext.type === "html-node";
const isRicosMarkExtension = (ext) => ext.type === "mark";
const isRicosFunctionalExtension = (ext) => ext.type === "extension";

export { Mark_Type, isExtensionConfig, isMarkConfig, isNodeConfig, isRicosFunctionalExtension, isRicosMarkExtension, isRicosNodeExtension };
//# sourceMappingURL=tiptap.js.map
